import { render, staticRenderFns } from "./ULBs.vue?vue&type=template&id=7fef86f4&"
import script from "./ULBs.vue?vue&type=script&lang=js&"
export * from "./ULBs.vue?vue&type=script&lang=js&"
import style0 from "./ULBs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports